import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys, colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamily, fontFamilySans, size } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

// ~-~-~-~-~-~-~-
// Container
// ~-~-~-~-~-~-~-
const wrapper: CSSProperties = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  backgroundColor: greys.white,
  width: "100%",
};

const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "25px 130px 64px",
  borderRadius: 10,
  maxWidth: 1250,
};

const lineItem: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  margin: "0 0 8px",
  alignItems: "center",

  "& .label": {
    flex: 1,
    color: greys.standard,
  },

  "& .sub-label": {
    paddingRight: 16,
    color: greys.slate,
  },
};

// ~-~-~-~-~-~-~-
// Inactive Subscription
// ~-~-~-~-~-~-~-
const checkoutFormContent: CSSProperties = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-around",
};

const checkoutForm: CSSProperties = {
  marginRight: 80,
};

const pricingRecurrence: CSSProperties = {
  marginBottom: 20,
};

const pricingRecurrenceForm: CSSProperties = {
  width: "100%",
};

const pricingRecurrenceSelect: CSSProperties = {
  padding: "12px 14px",
  border: `2px solid ${greys.paleGrey}`,
  "&:hover": {
    borderColor: greys.paleGrey,
  },
};

const pricingRecurrenceMenuItemSecondary: CSSProperties = {
  color: greys.slate,
  marginLeft: 5,
};

const badgePro: CSSProperties = {
  marginLeft: 10,
};

const seatForm: CSSProperties = {
  marginBottom: 20,
};

const seatFormItemHeader: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontSize: size.std,
  color: greys.standard,
};

const seatFormItemCta: CSSProperties = {
  marginLeft: spacing.xs,
  fontSize: size.md,
  whiteSpace: "nowrap",
  alignSelf: "start",
};

const seatFormItemSubHead: CSSProperties = {
  display: "flex",
  alignItems: "center",
  fontSize: size.md,
  color: greys.slate,
  margin: "10px 0",
  borderBottom: `1px dashed ${greys.slate}`,
  width: "fit-content",
  cursor: "pointer",
  "&:hover": {
    color: helpers.lighten(greys.slate, 0.15),
  },
};

const orgSeatsView: CSSProperties = {
  border: `1px solid ${greys.borderGrey}`,
  borderRadius: 5,
  padding: "10px 15px",
};

const seatFormItem: CSSProperties = {
  width: "100%",
  padding: 13,
  display: "flex",
  alignItems: "center",
};

const orgSeats: CSSProperties = {
  ...seatFormItem,
};

const teamSeats: CSSProperties = {
  ...seatFormItem,
};

const paymentMethod: CSSProperties = {
  marginBottom: 20,
};

const billingAddress: CSSProperties = {
  marginBottom: 20,
};

const checkoutConfirmation: CSSProperties = {};

const control: CSSProperties = {
  width: "100%",
};

const controlContent: CSSProperties = {
  display: "flex",
  flex: 1,
  flexDirection: "row",
  alignItems: "center",
  overflow: "hidden",
  "& .title-names": {
    flex: 1,
    "& .title": {
      fontSize: 14,
      color: greys.slate,
      whiteSpace: "nowrap",
      marginBottom: 10,

      "& .suggested": {
        marginLeft: 6,
        cursor: "pointer",
        color: colors.blueSky.darker,
        fontSize: "14px",
        paddingBottom: 2,
        borderBottom: `1px dashed ${colors.blueSky.darker}`,
      },
    },
  },
  "& .price": {
    display: "flex",
    alignItems: "baseline",
    fontFamily: fontFamilySans,
    fontSize: 14,
    color: greys.slate,
    "& .dollar": {
      fontFamily,
      fontWeight: "bold",
      fontSize: 28,
      color: greys.standard,
      marginRight: 5,
    },
  },
};

const reviewAndPurchaseContainer: CSSProperties = {
  background: helpers.opacity(greys.paleGrey, 0.4),
  width: 415,
  padding: 20,
  borderRadius: 5,
};

const paidSeatCountForm: CSSProperties = {};

const paidSeatCountUnderline: CSSProperties = {
  textDecoration: "underline",
};

const paidSeatCountSelect: CSSProperties = {
  padding: "12px 14px",
};

const paidSeatCountSelectLabel: CSSProperties = {
  fontWeight: "bold",
};

const divider: CSSProperties = {
  margin: "20px 0",
};

const checkoutItem: CSSProperties = {
  fontSize: 15,
  color: greys.standard,
  display: "flex",
  alignItems: "center",
  margin: "5px 0",
};

const checkoutLabel: CSSProperties = {
  marginLeft: 10,
};

const seatCount: CSSProperties = {
  fontWeight: "bold",
  margin: "0 15px 0 5px",
};

const minimumSeatCallout: CSSProperties = {
  fontSize: 13,
  color: greys.slate,
};

const miminumSeatHelpIcon: CSSProperties = {
  color: greys.slate,
  width: 15,
  height: 15,
  marginLeft: 5,
};

const costTotalContainer: CSSProperties = {};

const costTotalHeader: CSSProperties = {
  fontWeight: "bold",
  fontSize: 14,
  color: greys.slate,
  marginBottom: 10,
};

const costTotalLineItem: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "5px 0",
};

const costTotalLineItemAnnual: CSSProperties = {
  ...costTotalLineItem,
  margin: "10px 0",
};

const costArithmetic: CSSProperties = {
  fontSize: 15,
  color: greys.standard,
};

const costTotal: CSSProperties = {
  fontFamily,
  fontWeight: "bold",
  fontSize: 16,
  color: greys.standard,
  // textDecoration: 'line-through',
};

const promotion: CSSProperties = {
  fontSize: 15,
  color: colors.green.darker,
};

const finalCost: CSSProperties = {
  fontFamily,
  fontWeight: "bold",
  fontSize: 20,
};

const purchaseAgreement: CSSProperties = {
  fontSize: 12,
  lineHeight: 1.6,
  color: greys.slate,
  marginBottom: 15,
};

// ~-~-~-~-~-~-~-
// Stripe
// ~-~-~-~-~-~-~-
const stripeInput: CSSProperties = {
  border: `2px solid ${greys.paleGrey}`,
  borderRadius: 5,
  padding: "12px 14px",
  marginBottom: 10,
  "&:hover": {
    borderColor: greys.paleGrey,
  },
};

const billingAddressTextFieldContainer: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  margin: "10px 0",
};

const billingAddressInput: CSSProperties = {
  padding: "12px 14px",
  color: greys.slate,
  // hide the number arrows
  "&::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "&::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
};

const errorBox: CSSProperties = {
  display: "flex",
  alignItems: "center",
  background: helpers.lighten(colors.red.standard, 0.9),
  marginBottom: 15,
};

const calloutIcon: CSSProperties = {
  color: colors.red.standard,
  marginRight: 10,
};

const billingAdminContainer: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "150px",
};

const billingAdminText: CSSProperties = {
  fontSize: "14px",
  color: greys.slate,
  marginBottom: "15px",
  width: "600px",
  lineHeight: 1.5,
  textAlign: "center",
};

const billingAdminEmoji: CSSProperties = {
  height: 50,
  marginBottom: "20px",
};
const billingAdminHeader: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const billingAdminButton: CSSProperties = {
  fontSize: 14,
  margin: "20px 10px",
  height: 50,
  width: 175,
  color: greys.white,
  background: colors.green.standard,
  "&:hover": {
    background: helpers.opacity(colors.green.standard, 0.9),
  },
};

const maxSeatCountExceededMessage: CSSProperties = {
  lineHeight: "20px",
  fontSize: 13,
};
const bulletPoints: CSSProperties = {
  display: "flex",
  padding: "5px 0",
  alignItems: "center",
};

const bulletCheckmark: CSSProperties = {
  marginRight: "10px",
  fontSize: 17,
};

const maxSeatCountExceededList: CSSProperties = {
  margin: "20px 0",
  fontSize: 13,
};

export const styles = {
  wrapper,
  container,
  lineItem,
  checkoutFormContent,
  checkoutForm,
  pricingRecurrence,
  pricingRecurrenceForm,
  pricingRecurrenceSelect,
  pricingRecurrenceMenuItemSecondary,
  badgePro,
  seatForm,
  seatFormItemCta,
  seatFormItemHeader,
  seatFormItemSubHead,
  orgSeatsView,
  orgSeats,
  teamSeats,
  paymentMethod,
  billingAddress,
  checkoutConfirmation,
  control,
  controlContent,
  reviewAndPurchaseContainer,
  paidSeatCountForm,
  paidSeatCountUnderline,
  paidSeatCountSelect,
  paidSeatCountSelectLabel,
  divider,
  checkoutItem,
  checkoutLabel,
  seatCount,
  minimumSeatCallout,
  miminumSeatHelpIcon,
  costTotalContainer,
  costTotalLineItem,
  costTotalLineItemAnnual,
  costTotalHeader,
  costArithmetic,
  costTotal,
  promotion,
  finalCost,
  purchaseAgreement,
  stripeInput,
  billingAddressTextFieldContainer,
  billingAddressInput,
  errorBox,
  calloutIcon,
  billingAdminContainer,
  billingAdminText,
  billingAdminEmoji,
  billingAdminHeader,
  billingAdminButton,
  maxSeatCountExceededMessage,
  maxSeatCountExceededList,
  bulletPoints,
  bulletCheckmark,
};
